module.exports = __webpack_public_path__ + "img/simon.a6e35d87.jpeg";